import FJActionConstant from "../../constant/FJActionConstant";

let FJFontAction = (function () {

  return {

    /**
     * @description 更新加载中的字体
     * @param loadingFonts
     * @return {{type: string, loadingFonts}}
     */
    updateLoadingFontAction: function (loadingFonts) {
      return {
        type: FJActionConstant.SET_LOADING_FONT,
        loadingFonts: [...loadingFonts],
      }
    }
  }
})();

export default FJFontAction;